import {setSystemToLowercase} from './shared/serverFunctions';

/**
 * List: Locations with Inventory
 * List: Incoming Transfers
 * List: Received Transfers
 * List: Transfers by Memo
 * List: Transferred Products
 * List: Missing Scans
 * List: Repacks and Retail Boxes
 *
 * GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, DELETE
 */
export const RESOURCES = {
    LocationsWithInventory: {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            const sign = params.filter.sign;
            return {
                type: 'list',
                method: 'GET',
                title: 'Locations with Inventory',
                uri: localStorage.getItem('server') + '/api/v5/search/q/' + system + '/inventory/allLocations/' + sign
            };
        }
    },
    LocationsWithInventoryByProductName: {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let searchTerm = params.filter.search_name;
            const sign = params.filter.sign;
            return {
                type: 'list',
                method: 'GET',
                title: 'Locations with Inventory by Product',
                uri: localStorage.getItem('server') + '/api/v5/search/q/' + system + '/inventory/byProductName/' + encodeURIComponent(searchTerm) + '/' + sign
            };
        }
    },
    Transfers: {
        GET_LIST: function (params) {
            let system = setSystemToLowercase();
            let dateSince = (params && params.filter && params.filter.date_since) ? params.filter.date_since : '';
            return {
                type: 'list',
                method: 'GET',
                title: 'Incoming Transfers',
                uri: localStorage.getItem('server') + '/api/v5/search/q/' + system + '/transfers/unreceived/since/' + dateSince
            };
        }
    },
    ReceivedTransfers: {
        GET_LIST: function (params) {
            let system = setSystemToLowercase();
            let dateSince = (params && params.filter && params.filter.date_since) ? params.filter.date_since : '';
            return {
                type: 'list',
                method: 'GET',
                title: 'Received Transfers',
                uri: localStorage.getItem('server') + '/api/v5/search/q/' + system + '/transfers/received/since/' + dateSince
            };
        }
    },
    TransfersByMemo: {
        GET_LIST: function (params) {
            let system = setSystemToLowercase();
            let dateSince = (params && params.filter && params.filter.date_since) ? params.filter.date_since : '';
            const memo = params.filter && params.filter.filter_memo ? params.filter.filter_memo : null;
            return {
                type: 'list',
                method: 'GET',
                title: 'Transfers by Memo',
                uri: localStorage.getItem('server') + '/api/v5/search/q/' + system + '/transfers/any/since/' + dateSince + '/memoLike/' + encodeURIComponent(memo)
            };
        }
    },
    TransferredProducts: {
        GET_LIST: function (params) {
            let system = setSystemToLowercase();
            let dateSince = (params && params.filter && params.filter.date_since) ? params.filter.date_since : '';
            let condition = params.filter.condition;
            let path = params.filter.path;
            let searchTerm = (params.filter.search_name) ? encodeURIComponent(params.filter.search_name) : '';
            let uri = localStorage.getItem('server') + '/api/v5/search/q/' + system
                + '/transferItems/' + condition + '/since/' + dateSince + '/' + path + '/' + searchTerm;
            return {
                type: 'list',
                method: 'GET',
                title: 'Incoming Transfers',
                uri: uri
            };
        }
    },
    MissingScans: {
        GET_LIST: function (params) {
            let system = setSystemToLowercase();
            let dateSince = (params && params.filter && params.filter.date_since) ? params.filter.date_since : '';
            return {
                type: 'list',
                method: 'GET',
                title: 'Missing Scans',
                uri: localStorage.getItem('server') + '/api/v5/search/q/' + system + '/products/missingScans/' + dateSince
            };
        }
    },
    RepacksRetailBoxes: {
        GET_LIST: function (params) {
            let system = setSystemToLowercase();
            let collectionType = (params && params.filter && params.filter.collection_type) ? params.filter.collection_type : '';
            let fromDay = (params && params.filter && params.filter.date_from) ? params.filter.date_from : '';
            let toDay = (params && params.filter && params.filter.date_to) ? params.filter.date_to : '';
            let searchId = (params.filter.search_id) ? encodeURIComponent(params.filter.search_id) : '';
            let searchProduct = (params.filter.search_name) ? encodeURIComponent(params.filter.search_name) : '';
            let path;
            if (collectionType && collectionType !== 'any') {
                path = 'typeIs/' + collectionType;
            } else {
                if (searchId && searchId !== '') {
                    path = 'idLike/' + searchId;
                }
                if (searchProduct && searchProduct !== '') {
                    path = 'contentsLike/' + searchProduct;
                }
            }
            let uri = localStorage.getItem('server') + '/api/v5/search/q/' + system
                + '/collections/byModified/' + fromDay + '/' + toDay + '/' + path;
            return {
                type: 'list',
                method: 'GET',
                title: 'Missing Scans',
                uri: uri
            };
        }
    }
};

export default (type, resource, params) => {
    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "MissingScans"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    };
};



// WEBPACK FOOTER //
// ./src/Fuse/fuseSearchResourceMap.js